/**
 * @file: ListModel.js
 * @author: liuye11(liuye11@baidu.com)
 */

import ListModel from '../../common/ComponentListModel';
import {assign, omit} from 'lodash';
import uri from '@baidu/ve-ria/utils/uri';

export default class Model extends ListModel {
    filter = assign(this.filter, {
        timeRange: null,
        associatedId: null,
        associatedType: null
    });

    /**
     * @override
     */
    requestAderList() {}

    prepareParams(params) {
        // 去除路由 query中的 parent参数, 广告主
        return omit(params, ['parentId', 'parentType', 'aderId']);
    }

    getLinkUrl(params) {
        let routeQuery = this.getRouteQuery({});
        routeQuery.grandParentType = routeQuery.parentType;
        routeQuery.grandParentId = routeQuery.parentId;
        routeQuery.parentType = routeQuery.associatedType;
        routeQuery.parentId = routeQuery.associatedId;

        return uri.withQuery(
            '/stats/material/report/link',
            assign(routeQuery, params)
        );
    }
}
